import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  margin-top: 5px;\n  @media screen and (max-width: ", "px) {\n    display: none;\n  }\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  font-size: 14px;\n  color: ", ";\n  font-weight: 600;\n  margin-left: ", ";\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  color: inherit;\n  border: inherit;\n  outline: inherit;\n  min-width: 44px;\n  height: 44px;\n  padding: ", ";\n  border-radius: 100px;\n  ", ";\n\n  @media screen and (max-width: ", "px) {\n    background: ", ";\n  }\n\n  @media screen and (min-width: ", "px) {\n    background: ", ";\n  }\n\n  transition: all 100ms ease-in-out;\n  margin-right: 12px;\n  &:hover {\n    background: ", ";\n    opacity: 1;\n  }\n  &:active {\n    background: white;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React from 'react';
import { theme } from '../theme';
import { Ink } from '../Ink';
import { Tooltip, TooltipArrow } from '../Tooltip';
import styled from '../utils/styling/styled-components';
import { ACTION_BUTTON } from '../utils/testing/TestIDs';
import { ScreenReaderOnly } from '../ScreenReaderOnly';
var Container = styled.button(_templateObject(), function (props) {
  return props.rounded ? '0 10px' : '0 24px';
}, function (props) {
  return props.customButtonStyle;
}, theme.breakpoints.sm, function (props) {
  return props.actionBackgroundColor || props.theme.colors.white;
}, theme.breakpoints.sm + 1, function (props) {
  return props.actionBackgroundColor || props.theme.colors.ivory;
}, function (props) {
  return props.actionFadeColor || props.theme.colors.ivoryLight;
});
var Label = styled.div(_templateObject2(), function (props) {
  return props.danger ? props.theme.colors.red : props.theme.colors.slate;
}, function (props) {
  return props.icon ? '8px' : '0';
});
var ActionButtonTooltip = styled(Tooltip)(_templateObject3(), function (props) {
  return props.theme.breakpoints.sm;
});

var ActionButton = function ActionButton(_ref) {
  var icon = _ref.icon,
      onPress = _ref.onPress,
      text = _ref.text,
      tooltip = _ref.tooltip,
      className = _ref.className,
      customButtonStyle = _ref.customButtonStyle,
      actionText = _ref.actionText,
      actionBackgroundColor = _ref.actionBackgroundColor,
      actionFadeColor = _ref.actionFadeColor,
      _ref$testId = _ref.testId,
      testId = _ref$testId === void 0 ? "".concat(ACTION_BUTTON, "_").concat(text) : _ref$testId,
      _ref$danger = _ref.danger,
      danger = _ref$danger === void 0 ? false : _ref$danger;
  return /*#__PURE__*/React.createElement(Container, {
    actionBackgroundColor: actionBackgroundColor,
    actionFadeColor: actionFadeColor,
    "data-testid": testId,
    className: className,
    onClick: onPress,
    rounded: !text,
    customButtonStyle: customButtonStyle
  }, /*#__PURE__*/React.createElement(ScreenReaderOnly, null, actionText), tooltip && /*#__PURE__*/React.createElement(ActionButtonTooltip, {
    position: tooltip.position,
    visible: true
  }, tooltip.text, /*#__PURE__*/React.createElement(TooltipArrow, null)), /*#__PURE__*/React.createElement(Ink, {
    opacity: 0.02
  }), icon, text && /*#__PURE__*/React.createElement(Label, {
    danger: danger,
    icon: !!icon
  }, text));
};

export { ActionButton };